import { render } from "./HRDashboard.vue?vue&type=template&id=7a58dc4c&scoped=true"
import script from "./HRDashboard.vue?vue&type=script&lang=js"
export * from "./HRDashboard.vue?vue&type=script&lang=js"

import "./HRDashboard.vue?vue&type=style&index=0&id=7a58dc4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a58dc4c"]])

export default __exports__